import React, {createContext, useReducer} from 'react'
import {RouteStageReducer} from "../reducers/RouteStageReducer";

export const RouteStageContext = createContext();

const RouteStageContextProvider = (props) => {
    const state = {
        totalRoutes: '0',
        stagedRoutes: '0',
        departedRoutes: '0',
        preStagedCarts: '0',
        stagedCarts: '0',
        dwellingCartsDSP: '0',
        dwellingCartsFlex: '0',
        cartList: [],
        routeList: [],
        stageTaskPlanList: [],
        alert: {},
        lastUpdated: null,
        showPendingConfirmation: false,
        pendingConfirmationData: null
    }
    const [ viewModel, dispatch ] = useReducer(RouteStageReducer, state);
    return (
        <RouteStageContext.Provider value = {{viewModel, dispatch}}>
            {props.children}
        </RouteStageContext.Provider>
    )
}

export default RouteStageContextProvider


// WEBPACK FOOTER //
// ./src/components/stageStatus/context/RouteStageContext.js